import React, { useMemo } from 'react'
import {
  getCheckInDateFromURLSearchParams,
  getCheckOutDateFromURLSearchParams,
} from 'lib/url/searchUrlUtils'
import useQueryParams from 'hooks/useQueryParams'
import RadioInput from 'LuxKit/Radio/RadioInput'
import RadioGroup from 'LuxKit/Radio/RadioGroup'
import useBusinessTravellerBusinessBudgetFetcher from 'businessTraveller/hooks/useBusinessTravellerBusinessBudgetFetcher'
import styled from 'styled-components'
import { rem } from 'polished'
import { generatePriceFilterOptions, SHOW_ALL_BUDGET } from 'businessTraveller/utils/generatePriceFilterOptions'

const StyledRadioGroup = styled(RadioGroup)`
  margin-top: ${rem(8)};

  > * {
    margin-top: ${rem(6)};
  }
`

interface Props {
  filters: App.OfferListFilters;
  onChange: (value: string) => void;
}

function BusinessTravellerWithinBudgetListFilter(props: Props) {
  const { filters, onChange } = props

  const queryParams = useQueryParams()

  const { checkInDate, checkOutDate } = useMemo(() => {
    return {
      checkInDate: getCheckInDateFromURLSearchParams(queryParams),
      checkOutDate: getCheckOutDateFromURLSearchParams(queryParams),
    }
  }, [queryParams])

  const { currentBudget } = useBusinessTravellerBusinessBudgetFetcher()

  const budgetFilterOptions = useMemo(() => generatePriceFilterOptions(checkInDate, checkOutDate, currentBudget), [checkInDate, checkOutDate, currentBudget])

  const selectedBudget = filters?.priceLte ?? SHOW_ALL_BUDGET

  return (
    <StyledRadioGroup disabled={!currentBudget}>
      {budgetFilterOptions.map(option => (
        <RadioInput
          key={option.label}
          checked={!!option.value && option.value === selectedBudget}
          onChange={() => onChange(option.value)}
          name={option.label}
          value={option.value}
          disabled={!currentBudget}
          size="large"
        >
          {option.label}
        </RadioInput>
      ))}
    </StyledRadioGroup>
  )
}

export default BusinessTravellerWithinBudgetListFilter
